import { MD, XS } from "constants/sizes";
import GridParagraphWithImage from "segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image";
import classnames from "classnames";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import { useMemo } from "react";
import PrevCarouselArrow from "./prev-carousel-arrow";
import NextCarouselArrow from "./next-carousel-arrow";
import DefaultProps from "./default-props";
import { componentStyles } from "./sliding-card-grid-component.scss";

const SlidingCardGridComponent = ({ cards, cardsToShow, cardColor, cardInnerPadding, borderColor, isFullScreen }) => {
  const itemRenderer = (card) => (
    <GridParagraphWithImage
      {...card}
      borderColor={borderColor}
      cardColor={cardColor}
      padding={cardInnerPadding}
      width="100%"
      height="100%"
      titleSize={XS}
      textSize={MD}
    />
  );

  const areCardsToShowUnevenNumber = useMemo(
    () => Number(cardsToShow) < cards.length && !Number.isInteger(Number(cardsToShow)),
    [cards.length, cardsToShow]
  );

  const PrevArrow = ({ className, onClick }) => (
    <button
      type="button"
      className={classnames(className, "carousel-arrow-wrapper", "prev")}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={generateOnKeyDownHandler(onClick)}
    >
      <PrevCarouselArrow />
    </button>
  );

  const NextArrow = ({ className, onClick }) => (
    <button
      type="button"
      className={classnames(className, "carousel-arrow-wrapper", "next")}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={generateOnKeyDownHandler(onClick)}
    >
      <NextCarouselArrow />
    </button>
  );

  const carouselProps = {
    items: cards,
    itemRenderer,
    defaultIndex: 0,
    infinite: false,
    centerMode: false,
    slidesToShow: Number(cardsToShow) || undefined,
    centerPadding: "15%",
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  };

  return (
    <div
      className={classnames("sliding-card-grid-component", {
        "full-carousel-width": areCardsToShowUnevenNumber,
        "full-screen": isFullScreen
      })}
    >
      <Carousel {...carouselProps} />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

SlidingCardGridComponent.defaultProps = DefaultProps;
export default SlidingCardGridComponent;
